export default __webpack_public_path__ + "static/media/illustration.8b586b97.png";